import React from "react";

const TableWrapper = ({ children, className = "" }) => {
  return (
    <div
      className={`w-full rounded-2xl border border-line bg-card shadow-card overflow-hidden mb-6 mt-1 ring-1 ring-black/[0.02] ${className}`}
    >
      {children}
    </div>
  );
};

export default TableWrapper;
